import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import { Button, message, Modal, Upload } from "antd";
import { stationApi } from "@api/newApi";
import { Graph, Shape } from "@antv/x6";
import { Transform } from "@antv/x6-plugin-transform";
import { getUrlCode } from "@utils/common";
import FlowUnitProcess from "../../../components/flowUnitProcess";
import "./index.scss";

const { UPLOADER } = window.globalConfig;

Shape.HTML.register({
  shape: "custom-html",
  width: 80,
  height: 30,
  effect: ["data"],
  html(cell) {
    const { type, attrName, value, unit, isShowName } = cell.getData();
    const div = document.createElement("div");
    div.className = "custom-html";
    const customHead =
      isShowName == 1 ? `<div class="h">${attrName}</div>` : "";
    if (type == 1) {
      div.innerHTML = `
        ${customHead}
        <div class="${value == 1 ? "v success" : "v error"}">
          ${value == 1 ? "启动" : "停止"}
        </div>
      `;
    } else {
      div.innerHTML = `
        ${customHead}
        <div class="v" style="transform: scale(0.9)">${value}${unit}</div>
      `;
    }
    return div;
  },
});

const Pages = ({ selStationInfo = {} }) => {
  const [chainList, setChainList] = useState([]);
  const [checkedIds, setCheckedIds] = useState([]);
  const [bgImgStyle, setBgImgStyle] = useState({
    width: 1550,
    height: 785,
  });
  const [isShowPreviewModal, setIsShowPreviewModal] = useState(false);
  const [graphObj, setGraphObj] = useState();
  const [previewProcessData, setPreviewProcessData] = useState({});
  const [loading1, setLoading1] = useState(false);
  const [imgLoading, setImgLoading] = useState(false);
  const [canvasBg, setCanvasBg] = useState("");
  const [processunitInfo, setProcessunitInfo] = useState({});
  const processunitId = getUrlCode("id");

  useEffect(() => {
    initCanvas();
    return () => {
      graphObj && graphObj.destroy();
      setGraphObj(null);
    };
  }, []);

  const initCanvas = () => {
    setTimeout(() => {
      const graph = new Graph({
        container: document.getElementById("topologyCanvas"),
        width: bgImgStyle.width,
        height: bgImgStyle.height,
      });
      graph.use(
        new Transform({
          resizing: {
            enabled: true,
            grid: 15,
            minWidth: 1,
            minHeight: 1,
            orthogonal: false,
            restrict: false,
            preserveAspectRatio: false,
          },
        })
      );
      // 监听 button-remove 的点击事件
      graph.on("node:removed", ({ node }) => {
        const { data, shape } = node.store.data;
        if (shape == "custom-html") {
          setCheckedIds((prevIds) =>
            prevIds.filter((item) => item !== data.id)
          );
        }
      });
      setGraphObj(graph);
      findUnitFlow(graph);
      processunitId && getProcessUnitList();
    }, 0);
  };

  const findUnitFlow = (graphObj) => {
    stationApi.findUnitFlow(selStationInfo.id, processunitId).then((res) => {
      if (res.status !== "0") return;
      const { canvasHeight, canvasWidth, processFlowDeviceDiyDTOList } =
        res.data;

      if (canvasWidth && canvasHeight) {
        setBgImgStyle({ width: canvasWidth, height: canvasHeight });
        graphObj.resize(canvasWidth, canvasHeight);
      }
      setCanvasBg(res.data.canvasBg);

      if (
        processFlowDeviceDiyDTOList &&
        processFlowDeviceDiyDTOList.length > 0
      ) {
        const ids = [];
        processFlowDeviceDiyDTOList.forEach((item) => {
          ids.push(item.id);
          const graphNode = generateNode({
            ...item,
            x: item.posX,
            y: item.posY,
          });
          graphObj.addNode(graphNode);
        });
        setCheckedIds(ids);
      }
    });
  };

  // 获取工艺单元详情
  const getProcessUnitList = () => {
    stationApi.findProcessByStationId(selStationInfo.id).then((res) => {
      if (res.status !== "0") return;
      if (res.data && res.data.length > 0) {
        const find = res.data.find(
          (item) => item.processunitId === processunitId
        );
        if (find) {
          setProcessunitInfo(find);
          setChainList(find.diyAttrList);
        }
      }
    });
  };

  // 预览按钮
  const previewBtn = () => {
    const params = handleData();
    setPreviewProcessData(params);
    setIsShowPreviewModal(true);
  };

  const handleData = () => {
    const datas = graphObj.toJSON().cells;
    const processFlowDeviceDiyDTOList = [];
    datas.forEach((item) => {
      if (item.shape == "custom-html") {
        processFlowDeviceDiyDTOList.push({
          ...item.data,
          posX: item.position.x,
          posY: item.position.y,
          width: item.size.width,
          height: item.size.height,
          deviceDiyId: item.data.id,
        });
      }
    });
    const params = {
      stationId: selStationInfo.id,
      name: `${processunitInfo.processunitName}-工艺流程`,
      canvasWidth: bgImgStyle.width,
      canvasHeight: bgImgStyle.height,
      unitId: processunitId,
      processFlowDeviceDiyDTOList,
      canvasBg,
    };
    return params;
  };

  // 完成按钮
  const saveBtn = () => {
    const data = handleData();
    setLoading1(true);
    stationApi
      .updateProcessUnitFlow(data)
      .then((res) => {
        setLoading1(false);
        if (res.status !== "0") return;
        message.success("保存成功");
      })
      .catch(() => {
        setLoading1(false);
      });
  };

  const onDragStartFn = (event) => {
    event.dataTransfer.dropEffect = "move";
  };

  const onDragOverFn = (event) => {
    event.preventDefault(); // 确保浏览器允许拖拽
    event.dataTransfer.dropEffect = "move"; // 设置具体的拖拽效果
  };

  const onDragEndFn = (event, data) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    const topologyCanvas = document.getElementById("topologyCanvas");
    const offsetLeft = topologyCanvas.getBoundingClientRect().left;
    const offsetTop = topologyCanvas.getBoundingClientRect().top;
    let x = event.clientX - offsetLeft;
    let y = event.clientY - offsetTop;
    if (data.hide) return;
    if (x < 0 || y < 0) return message.error("请拖拽到画布上");
    const params = {
      ...data,
      x,
      y,
    };
    const nodeOptions = generateNode(params);
    graphObj.addNode(nodeOptions);
    setCheckedIds(() => {
      return [...checkedIds, data.id];
    });
  };

  const generateNode = (data) => {
    const { x, y } = data;
    const nodes = {
      shape: "custom-html",
      x,
      y,
      data,
      tools: ["button-remove"],
    };
    return nodes;
  };

  // 背景图样式改变事件
  const changeImgStyle = (e, type) => {
    let obj = { ...bgImgStyle };
    obj[type] = e.target.value * 1;
    setBgImgStyle({
      ...obj,
    });
  };

  // 修改背景底图样式
  const bgImgStyleSure = () => {
    graphObj.resize(bgImgStyle.width, bgImgStyle.height);
  };

  const uploadProps = {
    accept: "image/png",
    action: UPLOADER,
    listType: "picture",
    showUploadList: false,
    beforeUpload: (file) => {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
        message.error("你只能上传jpg或png图片格式");
      }
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        message.error("图片必需小于5M");
      }
      return isJpgOrPng && isLt5M;
    },
    onChange: (info) => {
      if (info.file.status === "uploading") {
        setImgLoading(true);
      }
      if (info.file.status === "done") {
        const res = info.file.response;
        setImgLoading(false);
        if (res.status == "0") {
          setCanvasBg(res.data.url);
        }
      }
    },
  };

  return (
    <div className="processUnitProcessFlow" id="processSet-step2-box">
      <div className="top-box">
        <div>
          <Upload {...uploadProps}>
            <Button type="default" loading={imgLoading}>
              设置背景底图
            </Button>
          </Upload>
          <span style={{ marginLeft: "20px" }}>
            {selStationInfo.name} / {processunitInfo.processunitName}
          </span>
        </div>
        <div className="btn-area">
          <Button
            type="primary"
            onClick={previewBtn}
            style={{ marginRight: 10 }}
          >
            预览
          </Button>
          <Button loading={loading1} type="primary" onClick={saveBtn}>
            完成
          </Button>
        </div>
      </div>
      <div className="con-box">
        <div className="process-area">
          <div className="tit">工艺环节({chainList.length})</div>
          <div className="process-box">
            {chainList.length == 0 && (
              <div className="no-data">该厂站暂无工艺单元</div>
            )}
            {chainList.map((item) => (
              <div
                className={classnames({
                  item: true,
                  disabledExist: checkedIds.includes(item.id),
                })}
                onDragStart={onDragStartFn}
                onDragOver={onDragOverFn}
                onDragEnd={(e) => onDragEndFn(e, item)}
                title={item.attrName}
                draggable={!checkedIds.includes(item.id)}
                key={item.id}
              >
                <div className="header">{item.attrName}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="canvas-box">
          {
            <div className="ipt-box">
              背景图样式设置： 宽：
              <input
                value={bgImgStyle.width}
                onChange={(e) => changeImgStyle(e, "width")}
                type="number"
              />
              高：
              <input
                value={bgImgStyle.height}
                onChange={(e) => changeImgStyle(e, "height")}
                type="number"
              />
              <Button size="small" onClick={bgImgStyleSure}>
                确 定
              </Button>
            </div>
          }
          <div
            onDragOver={(e) => e.preventDefault()}
            id="topologyCanvas"
            style={{ backgroundImage: `url(${canvasBg})` }}
          ></div>
        </div>
      </div>

      {/* 预览弹窗 begin */}
      {isShowPreviewModal && (
        <Modal
          title="预览"
          open={isShowPreviewModal}
          width={bgImgStyle.width}
          getContainer={() => document.getElementById("processSet-step2-box")}
          onCancel={() => {
            setIsShowPreviewModal(false);
            setPreviewProcessData({});
          }}
          footer={false}
        >
          <div style={{ height: bgImgStyle.height, background: "#101621", position: 'relative' }}>
            <FlowUnitProcess data={previewProcessData} />
          </div>
        </Modal>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pages);
